/** @typedef {{ legalName: string; taxId: string; addressLine: string; city: string; province: string; postalCode: string; country: string; email: string; phone: string }} InvoiceSeller */

const parsedVatRate = Number(process.env.REACT_APP_INVOICE_VAT_RATE);
export const INVOICE_VAT_RATE = Number.isFinite(parsedVatRate) && parsedVatRate >= 0
  ? parsedVatRate
  : 21;

/**
 * @returns {InvoiceSeller}
 */
export function getInvoiceSeller() {
  return {
    legalName: process.env.REACT_APP_INVOICE_SELLER_NAME || 'MarTestGo',
    taxId: process.env.REACT_APP_INVOICE_SELLER_TAX_ID || '',
    addressLine: process.env.REACT_APP_INVOICE_SELLER_ADDRESS || '',
    city: process.env.REACT_APP_INVOICE_SELLER_CITY || '',
    province: '',
    postalCode: process.env.REACT_APP_INVOICE_SELLER_POSTAL_CODE || '',
    country: process.env.REACT_APP_INVOICE_SELLER_COUNTRY || 'España',
    email: process.env.REACT_APP_INVOICE_SELLER_EMAIL || '',
    phone: process.env.REACT_APP_INVOICE_SELLER_PHONE || '',
  };
}
